import React from 'react';
import { motion } from 'framer-motion';
export function ProductMockup() {
  return <motion.div className="relative w-full max-w-md mx-auto" initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} data-id="element-155" data-mp="2tk10m4347a6z">
      <img src="https://cdn.magicpatterns.com/uploads/mHka6ugZ7QqN81jz9PYm57/392.png" alt="Megapack STRETCHING 360 — Curso completo: 12 tomos y 6 bonus en PDF" className="w-full h-auto drop-shadow-2xl" width={1080} height={1350} loading="eager"
    // @ts-ignore
    fetchpriority="high" decoding="async" data-id="element-156" data-mp="2jn4q5stnodzs" />
    </motion.div>;
}